"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getId = exports.getOffsetWidth = exports.getStyleValue = exports.createElement = exports.changeAriaControlsValue = exports.changeAriaExpandedValue = exports.isMobileDevice = exports.replaceClass = exports.toArray = exports.addFocusableAttributes = exports.addFocusable = exports.OUTLINE_ELEMENT_CLASS = void 0;
var common_constants_1 = require("../constants/common-constants");
exports.OUTLINE_ELEMENT_CLASS = 'outline-element';
function isFirstChildFocusable(component) {
    return (component.firstElementChild != null &&
        component.firstElementChild.getAttribute('disabled') !== null &&
        component.firstElementChild.getAttribute('disabled') !== undefined);
}
function isParentFocusable(component) {
    return (component.parentElement != null &&
        component.parentElement.getAttribute('disabled') !== null &&
        component.parentElement.getAttribute('disabled') !== undefined);
}
function validateFocusable(component) {
    var isFocusable = false;
    if (component != null && component.getAttribute('disabled') === null) {
        isFocusable = true;
        var firstChildFocusable = isFirstChildFocusable(component);
        var parentFocusable = isParentFocusable(component);
        if (firstChildFocusable || parentFocusable) {
            isFocusable = false;
        }
    }
    return isFocusable;
}
function addFocusable(component, ariaOptions, action, children, force) {
    if (force || validateFocusable(component)) {
        validateAriaOptions(ariaOptions, component);
        component.addEventListener('focusout', function (event) {
            component.classList.remove(exports.OUTLINE_ELEMENT_CLASS);
            if (children) {
                for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
                    var e = children_1[_i];
                    e.classList.remove(exports.OUTLINE_ELEMENT_CLASS);
                }
            }
        });
        addKeyFocusableEvents(component, children, action);
    }
}
exports.addFocusable = addFocusable;
function validateAriaOptions(ariaOptions, component) {
    if (ariaOptions) {
        if (ariaOptions.tabindex) {
            if (ariaOptions.tabindex !== '-1') {
                component.setAttribute('tabindex', ariaOptions.tabindex);
            }
        }
        delete ariaOptions.tabindex;
        for (var _i = 0, _a = Object.keys(ariaOptions); _i < _a.length; _i++) {
            var key = _a[_i];
            addFocusableAttributes(key, ariaOptions, component);
        }
    }
}
function addFocusableAttributes(key, ariaOptions, component) {
    var prefix = '';
    if (key !== 'role') {
        if (ariaOptions[key]) {
            prefix = 'aria-';
        }
    }
    component.setAttribute(prefix + key, ariaOptions[key]);
}
exports.addFocusableAttributes = addFocusableAttributes;
function addKeyFocusableEvents(component, children, action) {
    component.addEventListener('keyup', function (event) {
        var _a;
        if (action && action.preventDefault) {
            event.preventDefault();
        }
        var keyEvent = (_a = event.key) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        validateTabKeyEvent(keyEvent, component, children);
        validateEscapeKeyEvent(keyEvent, component, children);
        var availableKeys = ['enter', ' ', 'space', 'End', 'Home', 'ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'];
        if (action && availableKeys.includes(keyEvent)) {
            action.event();
        }
    });
}
function validateEscapeKeyEvent(keyEvent, component, children) {
    if (keyEvent === 'escape') {
        component.classList.remove(exports.OUTLINE_ELEMENT_CLASS);
        if (children) {
            for (var _i = 0, children_2 = children; _i < children_2.length; _i++) {
                var e = children_2[_i];
                e.classList.remove(exports.OUTLINE_ELEMENT_CLASS);
            }
        }
    }
}
function validateTabKeyEvent(keyEvent, component, children) {
    if (keyEvent === 'tab') {
        component.classList.add(exports.OUTLINE_ELEMENT_CLASS);
        if (children) {
            for (var _i = 0, children_3 = children; _i < children_3.length; _i++) {
                var e = children_3[_i];
                e.classList.add(exports.OUTLINE_ELEMENT_CLASS);
            }
        }
    }
}
function toArray(nodeList) {
    var array = [];
    nodeList.forEach(function (item) {
        array.push(item);
    });
    return array;
}
exports.toArray = toArray;
function replaceClass(element, oldClass, newClass, strict) {
    if (strict === void 0) { strict = false; }
    if (element) {
        var isPresent = true;
        if (strict) {
            isPresent = element.classList.contains(oldClass);
        }
        if (isPresent) {
            element.classList.remove(oldClass);
            element.classList.add(newClass);
        }
    }
}
exports.replaceClass = replaceClass;
function isMobileDevice() {
    return navigator.userAgent.indexOf('Mobile') !== -1;
}
exports.isMobileDevice = isMobileDevice;
function changeAriaExpandedValue(element, state) {
    var newState = typeof state == 'undefined' ? !element.getAttribute('aria-expanded') : state;
    element.setAttribute('aria-expanded', String(newState));
}
exports.changeAriaExpandedValue = changeAriaExpandedValue;
function changeAriaControlsValue(element, value) {
    element.setAttribute('aria-controls', value);
}
exports.changeAriaControlsValue = changeAriaControlsValue;
function createElement(_) {
    var el = document.createElement(_.element);
    _.classList && _.classList.forEach(function (c) { return el.classList.add(c); });
    _.props && Object.keys(_.props).forEach(function (key) { return el.setAttribute(key, _.props[key]); });
    _.innerText && (el.innerText = _.innerText);
    _.children && _.children.forEach(function (child) { return el.appendChild(child); });
    return el;
}
exports.createElement = createElement;
function getStyleValue(e, styleName) {
    var styleValue = '';
    if (document.defaultView && document.defaultView.getComputedStyle) {
        styleValue = document.defaultView.getComputedStyle(e, '').getPropertyValue(styleName);
    }
    else if (e.currentStyle) {
        styleName = styleName.replace(/\-(\w)/g, function (strMatch, p1) {
            return p1.toUpperCase();
        });
        styleValue = e.currentStyle[styleName];
    }
    return styleValue;
}
exports.getStyleValue = getStyleValue;
function getOffsetWidth(el) {
    return (parseInt(getStyleValue(el, common_constants_1.BcCommonConstants.MARGIN_LEFT), 10) +
        parseInt(getStyleValue(el, common_constants_1.BcCommonConstants.MARGIN_RIGHT), 10) +
        parseInt(getStyleValue(el, common_constants_1.BcCommonConstants.BORDER_LEFT_WIDTH), 10) +
        parseInt(getStyleValue(el, common_constants_1.BcCommonConstants.BORDER_RIGHT_WIDTH), 10) +
        parseInt(getStyleValue(el, common_constants_1.BcCommonConstants.PADDING_LEFT), 10) +
        parseInt(getStyleValue(el, common_constants_1.BcCommonConstants.PADDING_RIGHT), 10));
}
exports.getOffsetWidth = getOffsetWidth;
function getId(classRef) {
    var prefix = classRef.constructor.name;
    var array = new Uint32Array(1);
    var randomNumber = window.crypto.getRandomValues(array);
    return "".concat(prefix, ".").concat(randomNumber[0]);
}
exports.getId = getId;
